import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/retail-app/app-models-back.webp";
import { Link } from "gatsby";

function Strategyrealestate() {
  return (
    <section
      className="strategy_real_estate p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Accelerate Growth with <span>Custom Retail</span> App Models
            </h2>
            <p>
              Maximize growth by choosing the right retail app development
              services for your business. Our expert developers can guide you
              through selecting and implementing models that drive sales,
              optimize operations, and meet customer needs. Here are four
              high-impact models to include in your retail app development.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4 mb-xl-0">
            <div className="strategy-box">
              <div className="title">01</div>
              <div className="strategy-content">
                <h5>Startup Retail App</h5>
                <p>
                  Launch your brand with a performance-optimized, scalable
                  retail app. Whether native or cross-platform, we ensure your
                  app is robust, user-friendly, and market-ready, setting the
                  stage for lasting success.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4 mb-xl-0">
            <div className="strategy-box">
              <div className="title">02</div>
              <div className="strategy-content">
                <h5>Multi-Vendor Retail App</h5>
                <p>
                  Streamline operations and increase product variety by
                  onboarding multiple vendors. Our solution helps you manage
                  vendors and transactions efficiently, driving higher ROI
                  through a diverse, customer-centric experience.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4 mb-md-0">
            <div className="strategy-box">
              <div className="title">03</div>
              <div className="strategy-content">
                <h5>Cloud-Based CRM Retail App</h5>
                <p>
                  Centralize customer data, forecast sales trends, and enhance
                  engagement. Our cloud-based CRM apps provide real-time access
                  to customer insights, enabling informed decision-making and
                  secure data management.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="strategy-box">
              <div className="title">04</div>
              <div className="strategy-content">
                <h5>Retail App for Enterprises</h5>
                <p>
                  Elevate your business with a comprehensive retail solution
                  designed for large-scale operations. Manage inventory,
                  streamline workflows, and offer personalized experiences with
                  an enterprise-level app that integrates advanced analytics and
                  automation.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Strategyrealestate;
